"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_MOVES = exports.ON_ROUTE_STATUSES = exports.FINAL_STATUSES = exports.STATUS_LABELS = exports.SHIPMENT_STATUSES = void 0;
exports.holdKind = holdKind;
exports.releaseTarget = releaseTarget;
exports.findMove = findMove;
exports.nextStatuses = nextStatuses;
exports.actorMayMove = actorMayMove;
exports.SHIPMENT_STATUSES = [
    'CREATED',
    'COLLECTED',
    'RECEIVED_AT_HUB',
    'IN_HUB_TRANSFER',
    'ON_HOLD',
    'ASSIGNED',
    'OUT_FOR_DELIVERY',
    'IN_TRANSIT',
    'DELIVERED',
    'DELIVERED_LINK_PENDING',
    'PARTIALLY_DELIVERED',
    'FAILED',
    'RESCHEDULED',
    'RTO',
    'RETURNED_TO_CLIENT',
    'CANCELLED',
    'MISSING',
    'DAMAGED_LOST',
];
exports.STATUS_LABELS = {
    CREATED: 'Created',
    COLLECTED: 'Collected',
    RECEIVED_AT_HUB: 'Received at hub',
    IN_HUB_TRANSFER: 'In hub transfer',
    ON_HOLD: 'On hold',
    ASSIGNED: 'Assigned',
    OUT_FOR_DELIVERY: 'Out for delivery',
    IN_TRANSIT: 'In transit',
    DELIVERED: 'Delivered',
    DELIVERED_LINK_PENDING: 'Delivered – link pending',
    PARTIALLY_DELIVERED: 'Partially delivered',
    FAILED: 'Failed',
    RESCHEDULED: 'Rescheduled',
    RTO: 'RTO',
    RETURNED_TO_CLIENT: 'Returned to client',
    CANCELLED: 'Cancelled',
    MISSING: 'Missing',
    DAMAGED_LOST: 'Damaged / Lost',
};
/** No move out of these (D-0014). */
exports.FINAL_STATUSES = ['DELIVERED', 'RETURNED_TO_CLIENT', 'CANCELLED', 'DAMAGED_LOST'];
/** Statuses while the parcel is with a courier on the route. */
exports.ON_ROUTE_STATUSES = ['OUT_FOR_DELIVERY', 'IN_TRANSIT'];
/** "Hub staff" in plan 5.4 = hub manager and dispatcher (D-0005). */
const HUB_STAFF = ['hub_manager', 'dispatcher'];
const m = (n, from, to, by, reasonRequired = false, extra = {}) => ({ n, from, to, by, reasonRequired, ...extra });
// prettier-ignore
exports.STATUS_MOVES = [
    m(1, 'CREATED', 'COLLECTED', ['courier'], false, { condition: 'Collection scan at the client hub' }),
    m(2, 'CREATED', 'RECEIVED_AT_HUB', HUB_STAFF, false, { condition: 'First piece inscanned' }),
    m(3, 'CREATED', 'ON_HOLD', ['team_leader', 'hub_manager'], true),
    m(4, 'CREATED', 'CANCELLED', ['team_leader', 'ops_manager'], true, { condition: 'Client cancels before Blink has the parcel' }),
    m(5, 'CREATED', 'MISSING', [...HUB_STAFF, 'system'], true, { condition: 'Expected in the file but not scanned at receipt' }),
    m(6, 'COLLECTED', 'RECEIVED_AT_HUB', HUB_STAFF, false, { condition: 'First piece inscanned' }),
    m(7, 'COLLECTED', 'MISSING', [...HUB_STAFF, 'system'], true),
    m(8, 'RECEIVED_AT_HUB', 'ASSIGNED', [...HUB_STAFF, 'system'], false, { condition: 'Delivery task given to a courier' }),
    m(9, 'RECEIVED_AT_HUB', 'IN_HUB_TRANSFER', HUB_STAFF, false, { condition: 'Hub transfer task to another hub' }),
    m(10, 'RECEIVED_AT_HUB', 'ON_HOLD', ['team_leader', 'hub_manager'], true),
    m(11, 'RECEIVED_AT_HUB', 'RTO', ['team_leader'], true),
    m(12, 'RECEIVED_AT_HUB', 'MISSING', HUB_STAFF, true),
    m(13, 'RECEIVED_AT_HUB', 'DAMAGED_LOST', ['hub_manager'], true, { condition: 'With report' }),
    m(14, 'IN_HUB_TRANSFER', 'RECEIVED_AT_HUB', HUB_STAFF, false, { condition: 'Inscanned at the receiving hub' }),
    m(15, 'IN_HUB_TRANSFER', 'MISSING', [...HUB_STAFF, 'system'], true),
    m(16, 'ON_HOLD', 'RELEASE', ['team_leader', 'hub_manager'], true, { hold: 'IN_HUB' }),
    m(17, 'ON_HOLD', 'RTO', ['team_leader'], true, { hold: 'IN_HUB' }),
    m(18, 'ON_HOLD', 'CANCELLED', ['team_leader', 'ops_manager'], true, { hold: 'IN_HUB', condition: 'Only if Blink never had the parcel' }),
    m(19, 'ASSIGNED', 'OUT_FOR_DELIVERY', ['courier'], false, { condition: 'All pieces load-scanned and route started' }),
    m(20, 'ASSIGNED', 'RECEIVED_AT_HUB', HUB_STAFF, true, { condition: 'Unassigned; not an attempt' }),
    m(21, 'ASSIGNED', 'ON_HOLD', ['team_leader', 'hub_manager'], true),
    m(22, 'OUT_FOR_DELIVERY', 'IN_TRANSIT', ['courier'], false, { condition: 'Chosen as next stop' }),
    m(23, 'IN_TRANSIT', 'OUT_FOR_DELIVERY', ['courier'], false, { condition: 'Courier picks another next stop' }),
    ...['OUT_FOR_DELIVERY', 'IN_TRANSIT'].flatMap((from) => [
        m(24, from, 'DELIVERED', ['courier'], false, { condition: 'All pieces scanned, POD photo, cash collected (if COD)' }),
        m(25, from, 'DELIVERED_LINK_PENDING', ['system'], false, { condition: 'Closed with a payment-link reference' }),
        m(26, from, 'PARTIALLY_DELIVERED', ['courier'], false, { condition: 'Only if the merchant allows partial delivery' }),
        m(27, from, 'FAILED', ['courier'], true, { condition: 'Valid proof: reason, calls, WhatsApp, GPS photo' }),
        m(28, from, 'RECEIVED_AT_HUB', HUB_STAFF, true, { condition: 'Brought back without an attempt; not an attempt' }),
        m(29, from, 'DAMAGED_LOST', ['hub_manager'], true, { condition: 'With report' }),
        m(44, from, 'ON_HOLD', ['courier', 'team_leader', 'hub_manager'], true, { condition: 'Hold on the route; parcel stays with the courier, task stays open' }),
    ]),
    m(30, 'DELIVERED_LINK_PENDING', 'DELIVERED', ['system'], false, { condition: 'Paid-link matched' }),
    m(31, 'PARTIALLY_DELIVERED', 'RESCHEDULED', ['team_leader'], false, { condition: 'New task for the remaining pieces' }),
    m(32, 'PARTIALLY_DELIVERED', 'RTO', ['team_leader'], true),
    m(33, 'FAILED', 'RESCHEDULED', ['team_leader'], false, { condition: 'New task, new date' }),
    m(34, 'FAILED', 'RTO', ['team_leader', 'system'], true, { condition: 'System only after the maximum attempts when the rule is on' }),
    m(35, 'FAILED', 'ON_HOLD', ['team_leader', 'hub_manager'], true),
    m(36, 'RESCHEDULED', 'ASSIGNED', [...HUB_STAFF, 'system'], false, { condition: 'The new task is given to a courier' }),
    m(37, 'RESCHEDULED', 'ON_HOLD', ['team_leader', 'hub_manager'], true),
    m(38, 'RESCHEDULED', 'RTO', ['team_leader'], true),
    m(39, 'RTO', 'RETURNED_TO_CLIENT', [...HUB_STAFF, 'system'], false, { condition: 'Handed over to the client' }),
    m(40, 'RTO', 'MISSING', [...HUB_STAFF, 'system'], true),
    m(41, 'RTO', 'DAMAGED_LOST', ['hub_manager'], true, { condition: 'With report' }),
    m(42, 'MISSING', 'RECEIVED_AT_HUB', HUB_STAFF, false, { condition: 'Found and scanned' }),
    m(43, 'MISSING', 'DAMAGED_LOST', ['hub_manager'], true, { condition: 'Confirmed lost, with report' }),
    m(45, 'ON_HOLD', 'OUT_FOR_DELIVERY', ['courier', 'team_leader'], false, { hold: 'ON_ROUTE', condition: 'Customer called back the same day; same task' }),
    m(46, 'ON_HOLD', 'FAILED', ['courier'], true, { hold: 'ON_ROUTE', condition: 'Valid proof' }),
    m(47, 'ON_HOLD', 'RECEIVED_AT_HUB', HUB_STAFF, true, { hold: 'ON_ROUTE', condition: 'Brought back; not an attempt' }),
];
/** The kind of hold for a parcel on hold, from the status it had before. */
function holdKind(statusBeforeHold) {
    return statusBeforeHold && exports.ON_ROUTE_STATUSES.includes(statusBeforeHold) ? 'ON_ROUTE' : 'IN_HUB';
}
/** Where an in-hub hold is released to (D-0014 move 16). */
function releaseTarget(state) {
    return state.everReceived ? 'RECEIVED_AT_HUB' : 'CREATED';
}
/** The allowed move from the current state to `to`, or null when D-0014 does not allow it. */
function findMove(state, to) {
    if (exports.FINAL_STATUSES.includes(state.status))
        return null;
    const kind = state.status === 'ON_HOLD' ? holdKind(state.statusBeforeHold) : undefined;
    for (const mv of exports.STATUS_MOVES) {
        if (mv.from !== state.status)
            continue;
        if (mv.hold && mv.hold !== kind)
            continue;
        if (mv.to === 'RELEASE') {
            if (releaseTarget(state) === to)
                return mv;
            continue;
        }
        if (mv.to !== to)
            continue;
        // Cancelled only while Blink never had the parcel (SM-2: otherwise it is an RTO)
        if (to === 'CANCELLED' && state.everReceived)
            return null;
        return mv;
    }
    return null;
}
/** Statuses the parcel may move to from this state (any actor). */
function nextStatuses(state) {
    return exports.SHIPMENT_STATUSES.filter((s) => findMove(state, s));
}
/** Whether this actor may make the move. */
function actorMayMove(move, actor) {
    // D-0016: the super admin may make every move a staff role may make (not the courier's own or the system's)
    if (actor === 'super_admin')
        return move.by.some((a) => a !== 'courier' && a !== 'system');
    return move.by.includes(actor);
}
//# sourceMappingURL=status.js.map